<template>
    <div class="a-loader loader">
        <svg
            class="loader__shape"
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            viewBox="0 0 300 300"
            shape-rendering="geometricPrecision"
        >
            <path
                class="loader__clever"
                d="M214.8,95.5c0,0,61.7,49.7,0,107.9l-24-18.8l12,32.6c-56.5,54.8-106.2,0-106.2,0l12-29.1l-27.4,17.1
	            C28,140.1,82.8,93.8,82.8,93.8l27.4,17.1L93.1,81.8c0,0,49.7-61.7,113.1,0l-22.3,32.6L214.8,95.5z"
            />
            <circle
                ref="circle"
                class="loader__circle"
                stroke="white"
                stroke-width="20"
                fill="transparent"
                r="140"
                cx="150"
                cy="150"
            />
        </svg>
        <span class="loader__text">
            {{ progress }} %
        </span>
    </div>
</template>

<script>
import { LOADING_PROGRESS } from '../../../utils/constants/bus-events-constants';

export default {
    name: 'ALoader',
    data() {
        return {
            progress: 30
        }
    },
    mounted() {
        this.initEventsListeners();
    },
    beforeDestroy(){
        this.deactivateEventsListeners()
    },
    methods: {
        initEventsListeners() {
            this.$bus.$on(LOADING_PROGRESS, this.setLoadingProgress);
        },
        deactivateEventsListeners() {
            this.$bus.$off(LOADING_PROGRESS, this.setLoadingProgress);
        },
        setLoadingProgress(percent) {
            const circle = this.$refs.circle;
            // 140 is radius
            const circumference = 140 * 2 * Math.PI;
            circle.style.stroke = "white";
            circle.style.strokeDasharray = `${circumference} ${circumference}`;
            circle.style.strokeDashoffset = circumference;
            circle.style.strokeDashoffset = circumference - percent / 100 * circumference;
            this.progress = percent;
        }
    }
}
</script>

<style lang="scss">
@import "a-loader";
</style>